/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    object, func, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const styles = (theme) => ({
    editorContainer: {
        position: 'absolute',
        top: '44%',
        width: 140,
        right: 40,
        padding: 10,
        borderRadius: 4,
        border: `1px solid ${theme.palette.cgc?.shadowColor || 'rgba(0, 0, 0, 0.25)'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.shadowColor || 'rgba(0, 0, 0, 0.25)'}`,
        [theme.breakpoints.down('lg')]: {
            right: 15,
        },
        [theme.breakpoints.down('sm')]: {
            bottom: 25,
            left: 50,
            top: 'unset',
            right: 'unset',
            padding: 0,
        },
        [theme.breakpoints.down('xs')]: {
            bottom: 85,
            top: 'unset',
            right: 'unset',
            left: 'unset',
            padding: 0,
            marginRight: 10,
        },
    },
    title: {
        padding: 8,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    editorIcons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectButton: {
        width: '100%',
        height: '30px',
    },
});
const ImageEditorControlView = ({
    classes, x, y, setWidth, setImage, handleShowEditor, onMouseUp, onMouseDown, setX, setY,
}) => (
    <Grid container className={classes.editorContainer} spacing={2}>
        <Grid item xs={12} className={classes.title}>
            <Typography variant={6}>Adjust Photo</Typography>
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <RemoveIcon onClick={() => setWidth((20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowUpwardIcon onClick={() => { setY((y + 5)); }} onContextMenu={(event) => event.preventDefault()} onBlur={onMouseUp} onTouchStart={() => onMouseDown((y + 5), 'y', true)} onTouchEnd={onMouseUp} onMouseDown={() => onMouseDown((y + 5), 'y', true)} onMouseUp={onMouseUp} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <AddIcon onClick={() => setWidth((-20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowBackIcon onClick={() => { setX((x + 5)); }} onContextMenu={(event) => event.preventDefault()} onBlur={onMouseUp} onTouchStart={() => onMouseDown((x + 5), 'x', true)} onTouchEnd={onMouseUp} onMouseDown={() => onMouseDown((x + 5), 'x', true)} onMouseUp={onMouseUp} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <CloseIcon onClick={() => setImage('')} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowForwardIcon onClick={() => { setX((x - 5)); }} onContextMenu={(event) => event.preventDefault()} onBlur={onMouseUp} onTouchStart={() => onMouseDown((x - 5), 'x')} onTouchEnd={onMouseUp} onMouseDown={() => onMouseDown((x - 5), 'x')} onMouseUp={onMouseUp} />
        </Grid>
        <Grid item xs={12} className={classes.editorIcons}>
            <ArrowDownwardIcon onClick={() => { setY((y - 5)); }} onContextMenu={(event) => event.preventDefault()} onBlur={onMouseUp} onTouchStart={() => onMouseDown((y - 5), 'y', false)} onTouchEnd={onMouseUp} onMouseDown={() => onMouseDown((y - 5), 'y', false)} onMouseUp={onMouseUp} />
        </Grid>
        <Grid item xs={12}>
            <Button variant="contained" color="primary" className={classes.selectButton} onClick={() => handleShowEditor(false)}>Done</Button>
        </Grid>
    </Grid>
);
ImageEditorControlView.propTypes = {
    classes: object.isRequired,
    x: number.isRequired,
    y: number.isRequired,
    onMouseUp: func.isRequired,
    onMouseDown: func.isRequired,
    setWidth: func.isRequired,
    setImage: func.isRequired,
    handleShowEditor: func.isRequired,
    setX: func.isRequired,
    setY: func.isRequired,
};
export default withStyles(styles)(ImageEditorControlView);
